exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".two-lines__option, .two-lines__single-value, .two-lines__single-value {\n    white-space: pre-wrap !important;\n}\n\n.two-lines__value-container, .two-lines__value-container {\n    height: 3em;\n    margin-top: 4px !important;\n}\n\n.is-invalid {\n    border-color: #dc3545 !important;\n    background-image: none !important;\n}\n\n.was-validated, .form-control:valid{\n    background-image: none !important;\n}\n\n.was-validated, .form-control:invalid{\n    background-image: none !important;\n}\n", ""]);

// exports
